export default __webpack_public_path__ + "static/media/mongodb.9529047c.png";